document.addEventListener('DOMContentLoaded', (event) => {
  function initVideoAutoplayOnIntersect() {
    const videosToBindIntersection = document.querySelectorAll('video[data-autoplay-on-intersect]');

    videosToBindIntersection.forEach((video) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Pause all other videos and play the intersecting one
              document.querySelectorAll('video').forEach((vid) => vid.pause());
              entry.target.play();
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: parseFloat(video.dataset.autoplayOnIntersect) },
      );

      observer.observe(video);
    });
  }

  initVideoAutoplayOnIntersect();

  window.addEventListener('blocks:updated', initVideoAutoplayOnIntersect);
});
